export default "__VITE_ASSET__hlvqrBZd__"